/**
 * Features Component
 * 
 * Displays the key benefits section with animated feature cards.
 */

import '../styles/Features.css'

const FEATURES = [
  {
    icon: 'fas fa-bolt',
    title: 'Schnelle Genehmigung',
    description: 'Erhalten Sie innerhalb von 24 Stunden eine Antwort auf Ihre Anfrage.'
  },
  {
    icon: 'fas fa-shield-alt',
    title: 'Sicher & Vertraulich',
    description: 'Ihre Daten werden verschlüsselt und sicher behandelt.'
  },
  {
    icon: 'fas fa-hand-holding-usd',
    title: 'Keine Antragsgebühren',
    description: 'Sie zahlen nur die einmalige Kartengebühr - keine versteckten Kosten.'
  },
  {
    icon: 'fas fa-users',
    title: 'Für Alle Zugänglich',
    description: 'Auch Menschen mit bestehenden Schulden können sich bewerben.'
  }
]

function Features() {
  return (
    <section className="features" role="region" aria-labelledby="features-title">
      <div className="container">
        <h2 id="features-title" className="section-title">
          Warum uns wählen?
        </h2>
        
        <div className="features-grid">
          {FEATURES.map((feature, index) => (
            <div 
              key={index} 
              className="feature-item"
              style={{ '--feature-index': index }}
            >
              <div className="feature-icon">
                <i className={feature.icon} aria-hidden="true"></i>
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Features
